<template>
  <div>
    <button type="button" class="question-btn" @click="showDialog = true">
      <span>?</span>
    </button>
    <md-dialog :md-active.sync="showDialog" :md-backdrop="true" class="popin-default">
    <md-dialog-title>{{ title }}</md-dialog-title>

    <md-dialog-content>
      <div class="md-layout">
        <div class="md-layout-item" v-html="text">
        </div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
        <button class="button" @click="showDialog = false">{{ $t('popinClose') }}</button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: 'ESPopin',
  props: {
    title: String,
    text: String,
  },
  data: function data() {
    return {
      showDialog: false,
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Popin.vue